import { createContext } from "react";

const LogBookContext = createContext();

export default LogBookContext;
